import DistrictSettings from './DistrictSettings';
export default DistrictSettings;
